import ConfigParameter, { gettext } from "../ConfigParameter";

export default class PaddingItemBottom extends ConfigParameter {

    constructor() {
        super('paddingItemBottom', 'number', gettext('Padding bottom'), 'itemPosition', {value: 15, unit: 'px'}, ['px','%']);
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/PaddingItemBottom.js